import { AuthLayout } from '@/features/auth/AuthLayout';
import { RegisterForm } from '@/features/auth/RegisterForm';
import { RedirectIfAuthed } from '@/features/auth/auth-guard';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/register')({
  component: RegisterPage,
});

function RegisterPage() {
  const { t } = useTranslation();
  return (
    <RedirectIfAuthed>
      <AuthLayout eyebrow={t('auth.register.eyebrow', { defaultValue: 'Create your account' })}>
        <RegisterForm />
      </AuthLayout>
    </RedirectIfAuthed>
  );
}
